import React from 'react';
// import styled from "styled-components";

/*
 *  @Description:   Stateless component that renders an Download Icon.
 */

const Resource = () => {

    return (<g id="id">
            <path
                d="m16.2 8.51h-4.2c-0.385 0-0.699 0.314-0.699 0.698v5.58c0 0.384 0.315 0.698 0.699 0.698h4.2c0.385 0 0.699-0.314 0.699-0.698v-5.58c0-0.384-0.315-0.698-0.699-0.698z"/>
            <path d="m8.61 9.38h-1.1c-0.215 0-0.387 0.179-0.387 0.402v4.44c0 0.224 0.172 0.402 0.387 0.402h1.1"/>
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        </g>


    )
};

export default Resource;
